export default __webpack_public_path__ + "static/17-08cae260aef68507a2d500f655278adb.webp";